const initialState = {
  data:{}
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_RIGHTS':
      return {
        ...state,
        data: action.payload
      }
    case 'EDIT_RIGHT':
      if(action.payload.check){
        if (state.data[action.payload.action_id]) {
          return {
            ...state,
            data: {
              ...state.data,
              [action.payload.action_id]: [
                ...state.data[action.payload.action_id],
                action.payload.usrg_id
              ]
            }
          }
        }
        else {
          return {
            ...state,
            data: {
              ...state.data,
              [action.payload.action_id]: [action.payload.usrg_id]
            }
          }
        }
      }
      else {
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.action_id]: state.data[action.payload.action_id]
              .filter(id => id !== action.payload.usrg_id)
          }
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/rights.js